/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AppointmentActionResponse, ApproveAppointmentsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    approveAppointments: build.mutation<AppointmentActionResponse, ApproveAppointmentsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/appointments/approve`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as approveAppointmentsApi };
export const { useApproveAppointmentsMutation } = injectedRtkApi;
